import React from 'react';
import { SGSAccordion, SGSButton, SGSDeleteIcon, SGSEditIcon, PageLoader } from 'components';
import { useQuery } from 'core/hooks';
import { faqService } from 'core/services';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { bySortOrder } from 'core/utils';

type Props = {};

const FAQQuestionList: React.FC<Props> = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const { data, loading, refresh } = useQuery(faqService.getRubriquesWithFaqs);

    return (
        <div>
            <div className="mb-4">
                <SGSButton
                    variant="outlined"
                    className="mr-2"
                    onClick={() => {
                        history.push('/faq');
                    }}
                >
                    {t('global.back')}
                </SGSButton>
                <SGSButton
                    onClick={() => {
                        history.push('/faq/questions/create');
                    }}
                >
                    {t('help.faq.question.create')}
                </SGSButton>
            </div>
            <PageLoader loading={loading}>
                {data?.sort(bySortOrder).map((rubrique) => {
                    return (
                        <div key={rubrique.id} className="mb-4">
                            <div>{rubrique.name}</div>
                            <div>
                                {rubrique.faqs.map((rubriqueQuestion) => (
                                    <SGSAccordion
                                        key={rubriqueQuestion.faq.id}
                                        summary={
                                            <div className="d-flex justify-content-between flex-grow-1">
                                                <strong>{rubriqueQuestion.faq.title}</strong>
                                                <div>
                                                    <SGSEditIcon
                                                        className="mr-2"
                                                        onClick={() => {
                                                            history.push(
                                                                `/faq/questions/edit/${rubriqueQuestion.faq.id}`,
                                                            );
                                                        }}
                                                    />
                                                    <SGSDeleteIcon
                                                        onClick={() =>
                                                            faqService.deleteFaq(rubriqueQuestion.faq.id).then(refresh)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        }
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: rubriqueQuestion.faq.content }}></div>
                                    </SGSAccordion>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </PageLoader>
        </div>
    );
};

export default FAQQuestionList;
